import { get, put, post } from '../utils/axios/https';
import { gasPrice, loadWeb3, maxGasForTokenSend, newTokenContract } from '../utils/wallet';
import { nex_abi } from '../wallet/containers/abi';

export default {
    getTransactions: (statusFilter) => {
        const url = statusFilter
            ? `api/transacciones/?estado=${statusFilter}`
            : `api/transacciones/`;
        return get(url);
    },
    getTransactionsFilter: (statusFilter, page, searchText, startDate, endDate, order) => {
        let result = [];
        if (statusFilter)
            result.push(`estado=${statusFilter === 'emptyValue' ? '' : statusFilter}`);
        if (searchText) result.push(`search_text_str=${searchText}`);
        if (startDate) result.push(`start_date_str=${startDate}`);
        if (endDate) result.push(`end_date_str=${endDate}`);
        if (page) result.push(`page=${page}`);
        if (order) result.push(order);
        const queryString = result.length > 0 ? `?${result.join('&')}` : '';
        const url = `api/transacciones/${queryString}`;
        console.log('🔍 Normal Transactions API URL:', url);
        return get(url);
    },
    // new volume endpoints for OS and Roche
    getVolumeTransactions: (statusFilter) => {
        const url = statusFilter
            ? `api/volumen/transacciones/?estado=${statusFilter}`
            : `api/volumen/transacciones/`;
        return get(url);
    },
    getVolumeTransactionsFilter: (statusFilter, page, searchText, startDate, endDate, order) => {
        let result = [];
        if (statusFilter)
            result.push(`estado=${statusFilter === 'emptyValue' ? 'NONE' : statusFilter}`);
        if (searchText) result.push(`search_text_str=${searchText}`);
        if (startDate) result.push(`start_date_str=${startDate}`);
        if (endDate) result.push(`end_date_str=${endDate}`);
        if (page) result.push(`page=${page}`);
        if (order) result.push(order);
        const queryString = result.length > 0 ? `?${result.join('&')}` : '';
        const url = `api/volumen/transacciones/${queryString}`;
        console.log('🔍 Volume Transactions API URL:', url);
        return get(url);
    },
    getVolumeTransactionsNotPaginated: (statusFilter, searchText, startDate, endDate, order) => {
        let result = ['paginate=false'];
        if (statusFilter)
            result.push(`estado=${statusFilter === 'emptyValue' ? '' : statusFilter}`);
        if (searchText) result.push(`search_text_str=${searchText}`);
        if (startDate) result.push(`start_date_str=${startDate}`);
        if (endDate) result.push(`end_date_str=${endDate}`);
        if (order) result.push(order);
        const queryString = `?${result.join('&')}`;
        const url = `api/volumen/transacciones/${queryString}`;
        console.log('🔍 Volume Transactions (no pagination) API URL:', url);
        return get(url);
    },
    // end new volume stuff
    getTransactionsEmitted: () => get(`api/blockchain/transacciones/emitidas/`),
    getTransactionsReceived: () => get(`api/blockchain/transacciones/recibidas/`),
    getVolumeTransactionsEmitted: () => get(`api/blockchain/transacciones/emitidas/`),
    getVolumeTransactionsReceived: () => get(`api/blockchain/transacciones/recibidas/`),
    getNotPaginatedTransactions: (statusFilter, page, searchText, startDate, endDate, order) => {
        let result = ['paginate=false'];
        if (statusFilter)
            result.push(`estado=${statusFilter === 'emptyValue' ? '' : statusFilter}`);
        if (searchText) result.push(`search_text_str=${searchText}`);
        if (startDate) result.push(`start_date_str=${startDate}`);
        if (endDate) result.push(`end_date_str=${endDate}`);
        if (order) result.push(order);
        const queryString = result.length > 0 ? `?${result.join('&')}` : '';
        return get(`api/transacciones/${queryString}`);
    },
    getOsAuditTransactions: () => get(`api/auditoria/`),
    getAuditorTransactions: () => get(`api/auditor/me/registros/`),
    getSharedRiskTransactions: () => get(`api/riesgocompartido`),
    getTransactionMonitorTransactions: (statusFilter) =>
        get(`api/interfacelog/${statusFilter || ''}`),
    postAuditorTransactions: (body, id) => post(`api/auditoria/${id}/historial/`, body),
    updateAuditorTransactions: (body, id) => put(`api/auditoria/${id}/historial/`, body),
    updateSharedRiskTransactions: (body, id) => put(`api/riesgocompartido/${id}/`, body),
    putTransactionsAplications: (body) => put(`api/transacciones/cambiaraplicacion/`, body),
    validateTransactions: (body) => put(`api/transacciones/validar/`, body),
    rejectTransactions: (body) => put(`api/transacciones/rechazar/`, body),
    getNexMonitorTransactions: (statusFilter) => {
        const url = statusFilter
            ? `api/blockchain/transacciones/?estado=${statusFilter}`
            : `api/blockchain/transacciones/`;
        return get(url);
    },
    getNexMonitorTransactionsFilter: (
        statusFilter,
        page,
        searchText,
        startDate,
        endDate,
        order,
    ) => {
        let result = [];
        if (statusFilter)
            result.push(`estado=${statusFilter === 'emptyValue' ? '' : statusFilter}`);
        if (searchText) result.push(`search_text_str=${searchText}`);
        if (startDate) result.push(`start_date_str=${startDate}`);
        if (endDate) result.push(`end_date_str=${endDate}`);
        if (page) result.push(`page=${page}`);
        if (order) result.push(order);
        const queryString = result.length > 0 ? `?${result.join('&')}` : '';
        const url = `api/blockchain/transacciones/${queryString}`;
        console.log('🔍 NEX Monitor Transactions API URL:', url);
        return get(url);
    },
    getNexMonitorTransactionsNotPaginated: (
        statusFilter,
        searchText,
        startDate,
        endDate,
        order,
    ) => {
        let result = ['paginate=false'];
        if (statusFilter)
            result.push(`estado=${statusFilter === 'emptyValue' ? '' : statusFilter}`);
        if (searchText) result.push(`search_text_str=${searchText}`);
        if (startDate) result.push(`start_date_str=${startDate}`);
        if (endDate) result.push(`end_date_str=${endDate}`);
        if (order) result.push(order);
        const queryString = `?${result.join('&')}`;
        const url = `api/blockchain/transacciones/${queryString}`;
        console.log('🔍 NEX Monitor Transactions (no pagination) API URL:', url);
        return get(url);
    },
    validatePayments: (body) => put(`api/transacciones/iniciarpago/`, body),
    broadcastPayments: (body) => put(`api/transacciones/broadcastpago/`, body),
    pay: (body) => put(`api/transacciones/registrarpago/`, body),
    trackPaymentsErrors: (body) => put(`api/transacciones/resetpago/`, body),

    // Volume-specific payment endpoints
    validateVolumePayments: (body) => put(`api/volumen/transacciones/iniciarpago/`, body),
    broadcastVolumePayments: (body) => put(`api/volumen/transacciones/broadcastpago/`, body),
    payVolume: (body) => put(`api/volumen/transacciones/registrarpago/`, body),
    trackVolumePaymentsErrors: (body) => put(`api/volumen/transacciones/resetpago/`, body),
    rejectVolumeTransactions: (body) => put(`api/volumen/transacciones/rechaza/`, body),
    sendDataToSAP: (body) => put(`api/blockchain/contabilizar-recepcion/`, body),
    resendDataToSAP: (body) => put(`api/reenviarsap/`, body),
    getGrantingMonitorAddresses: () => get('api/blockchain/addresses/'),

    grantAddresses: (body) => post('api/blockchain/grantaddresses/', body),
    getPatientAuditor: (id) => get(`api/auditoria/${id}/`),
    getPatientEvidenceAuditor: (auditorId, id) =>
        get(`api/auditoria/${auditorId}/pacientecontrato/${id}/evidencias`),

    getWhiteListedAddresses: (address, fundsKey) => {
        const { tokenContract } = newTokenContract(fundsKey);
        return new Promise((resolve, reject) => {
            tokenContract.methods.getWhitelisted().call(
                // { from: address, gas: maxGasForTokenSend, gasPrice },
                { from: address, gas: '2000000', gasPrice },
                (error, whitelisted) => {
                    if (error) {
                        reject(error);
                    } else {
                        resolve(whitelisted);
                    }
                },
            );
        });
    },

    addressIsWhiteLister: (address, fundsKey) => {
        const { tokenContract } = newTokenContract(fundsKey);
        return new Promise((resolve, reject) => {
            tokenContract.methods.isWhiteLister(address).call((error, receipt) => {
                if (error) {
                    reject(error);
                } else {
                    if (!receipt) reject('Address no válida');
                    resolve(receipt);
                }
            });
        });
    },

    addToWhitelisted: (addressToAdd, address, fundsKey) => {
        const { tokenContract } = newTokenContract(fundsKey);
        return new Promise((resolve, reject) => {
            tokenContract.methods
                .addToWhitelisted(addressToAdd)
                .send({ from: address, gas: maxGasForTokenSend, gasPrice })
                .on('receipt', function (receipt) {
                    resolve(receipt);
                })
                .on('error', function (error) {
                    reject(error);
                });
        });
    },

    transferJAC: (addressGrant, fundsKey, address) => {
        const web3 = loadWeb3(fundsKey);
        const txObject = {
            from: address, // Roche
            to: addressGrant, // Address a grantear
            value: web3.utils.toWei('0.5', 'ether'),
            gas: maxGasForTokenSend,
            gasPrice,
        };
        return new Promise((resolve, reject) => {
            web3.eth
                .sendTransaction(txObject)
                .on('receipt', function (receipt) {
                    resolve(receipt);
                })
                .on('error', function (error) {
                    reject(error);
                });
        });
    },

    transferJacDirectPayment: (address, fundsKey, addressPD) => {
        const web3 = loadWeb3(fundsKey);
        const txObject = {
            from: address,
            to: addressPD,
            value: web3.utils.toWei('0.5', 'ether'),
            gas: maxGasForTokenSend,
            gasPrice,
        };
        return new Promise((resolve, reject) => {
            web3.eth
                .sendTransaction(txObject)
                .on('error', function (error) {
                    reject(error);
                })
                .on('receipt', function (receipt) {
                    resolve(receipt);
                });
        });
    },

    grantDirectPayment: (address, addressPD, fundsKeyPD) => {
        const { tokenContract: tokenContractPD } = newTokenContract(fundsKeyPD);
        const spender = address;
        const bigAllowance = '999999999000000000000000000';
        return new Promise((resolve, reject) => {
            tokenContractPD.methods
                .increaseAllowance(spender, bigAllowance)
                .send({ from: addressPD, gas: maxGasForTokenSend, gasPrice })
                .on('error', function (error) {
                    reject(error);
                })
                .on('receipt', function (receipt) {
                    resolve(receipt);
                });
        });
    },

    postSendNex: (addAddress, amount, address, fundsKey, nonce) => {
        return new Promise((resolve, reject) => {
            const { w3, tokenContract } = newTokenContract(fundsKey);
            tokenContract.methods
                .transfer(addAddress, w3.utils.toWei(amount, 'ether'))
                .send({ from: address, gas: maxGasForTokenSend, gasPrice, nonce })
                .on('transactionHash', function () {})
                .on('error', function (error) {
                    reject(error);
                })
                .on('receipt', function (receipt) {
                    resolve(receipt);
                });
        });
    },
    postMultipleSendsNex: (addAddress, amount, address, fundsKey, nonce) => {
        const w3 = loadWeb3(fundsKey);
        return new Promise((resolve, reject) => {
            const tokenContract = new w3.eth.Contract(nex_abi, process.env.REACT_APP_TOKEN_NEX);
            tokenContract.methods
                .transfer(addAddress, w3.utils.toWei(amount, 'ether'))
                .send({ from: address, gas: maxGasForTokenSend, gasPrice, nonce })
                .on('transactionHash', function () {})
                .on('error', function (error) {
                    reject(error);
                })
                .on('receipt', function (receipt) {
                    resolve(receipt);
                });
        });
    },
};
